export default [
  {
    answer: 1,
    questions: [
      'Если сайт красиво выглядит, то он точно настоящий и не опасный.',
      'Cайты мошенников часто почти ничем не отличаются от настоящих — но адрес точно будет другой!',
    ],
  },
  {
    answer: 0,
    questions: [
      'В отзывах на проверенных сайтах можно найти много полезной информации.',
      'Нет смысла читать отзывы, у меня своё мнение.',
    ],
  },
  {
    answer: 0,
    questions: [
      'Если тебе показалось, что от имени друга тебе пишет мошенник, лучше сразу позвонить другу по телефону.',
      'Если тебе показалось, что от имени друга тебе пишет мошенник, лучше сразу напрямую задать ему вопрос, мошенник ли он.',
    ],
  },
]
